import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";
import {Cancel as CloseIcon} from "@material-ui/icons";
import MarkerSettingsMenu from "./Menus/MarkerSettingsMenu";
import MarkerTypesMenu from "./Menus/MarkerTypesMenu";
import MarkerCategoriesMenu from "./Menus/MarkerCategoriesMenu";
import AccountMenu from "./Menus/AccountMenu";
import SidebarMainMenu from "./SidebarMainMenu";
import Logo from "../Logo";
import {appContainer, Subscribe} from "../../contexts/app";
import "./style.scss";

export class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenu: "main"
    };
  }

  render() {
    return (
      <Drawer className={"sidebar " + this.getMobileTogglerClass()} variant="persistent" anchor="left" open>
        <div className="appSidebar">
          <Logo className="desktopOnlyLogo" width="120" />
          <CloseIcon className="sidebarCloseBtn" onClick={this.props.onClose} />
          <Switch>
            <Route path="/account" render={routeProps => this.renderAccountMenu(routeProps)} />
            <Route path="/marker-settings" component={MarkerSettingsMenu} />
            <Route path="/marker-types" render={routeProps => this.renderMarkerTypesMenu(routeProps)} />
            <Route path="/marker-categories" render={routeProps => this.renderMarkerCategoriesMenu(routeProps)} />
            <Route render={routeProps => this.renderMainMenu(routeProps)} />
          </Switch>
        </div>
      </Drawer>
    );
  }

  getMobileTogglerClass() {
    return this.props.sidebarOpen ? "mobileToggleOn" : "mobileToggleOff";
  }

  renderAccountMenu({match}) {
    const {currentUser, onClose} = this.props;
    return <AccountMenu match={match} currentUser={currentUser} onClose={onClose} />;
  }

  renderMarkerTypesMenu({match, location}) {
    const {currentUser, markerTypeCategories, markerTypes, onClose} = this.props;
    return (
      <MarkerTypesMenu
        categories={markerTypeCategories.toList()}
        markerTypes={markerTypes.toList()}
        currentUser={currentUser}
        match={match}
        location={location}
        onClose={onClose}
      />
    );
  }

  renderMarkerCategoriesMenu({match, location}) {
    const {currentUser, markerTypeCategories, markerTypes} = this.props;
    return (
      <MarkerCategoriesMenu
        categories={markerTypeCategories.toList()}
        markerTypes={markerTypes.toList()}
        currentUser={currentUser}
        match={match}
        location={location}
      />
    );
  }

  renderMainMenu({match}) {
    const {currentUser, onClose, sessions, currentAccount} = this.props;
    return (
      <SidebarMainMenu
        currentUser={currentUser}
        currentAccount={currentAccount}
        sessions={sessions}
        onClose={onClose}
        match={match}
      />
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object.isRequired,
  sessions: PropTypes.array.isRequired,
  currentAccount: PropTypes.object.isRequired,
  markerTypeCategories: PropTypes.object.isRequired,
  markerTypes: PropTypes.object.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default props => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return (
          <SidebarContent
            {...props}
            onClose={() => {
              app.set("sidebarOpen", false);
            }}
            markerTypeCategories={app.state.get("markerTypeCategories")}
            markerTypes={app.state.get("markerTypes")}
            currentUser={app.state.get("currentUser")}
            currentAccount={app.state.get("currentAccount")}
          />
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js